document.addEventListener('click', function(event) {
  const offerButton = event.target.closest('.md-offer-row__atc');
  if (!offerButton) return;

  const row = offerButton.closest('.md-offer-row');
  if (!row) return;

  const quantity = row.dataset.quantity;
  const productInfo = offerButton.closest('product-info') || document;

  const quantityInput = productInfo.querySelector('input[name="quantity"]');
  const realAtcButton = productInfo.querySelector('button[name="add"]');

  if (quantityInput) {
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  if (realAtcButton) {
    realAtcButton.click();
  }
});